/*!
 * Configuration for SOS google maps widget
 * 
 * Copyright (c) 2015 viazenetti
 * @author ch
 * @version .9
 */

vz = window.vz || {};
vz.sos = vz.sos || {};
vz.sos.config = vz.sos.config || {};
vz.sos.config.MapNavigation = {
    debug: !1,
    baseUrl: document.location.protocol + "//" + document.location.host,
    worldBaseUrl: SOSMapConfig.worldBaseUrl,
    domIds: {
        contentContainerMain: "article",
        contentContainerContent: ".pageContent", //this gets replaced with the content of the clicked location
        contentToRemove: ".remove-on-navigation", //this gets removed when a new location is clicked
        contentUpdateToH1: ".ig-dam-content h2.section-heading", //change ig-dam content h1 to h1
        contentContainerBreadcrumb: ".breadcrumb",
        contentContainerTitle: ".wwhTitle",
        main: "#mapNav",
        map: {
            main: "#mapNavMapContainer",
            canvas: "#mapNavMap",
            loader: "#mapNavLoader",
            notice: "#mapNavNotice"
        },
        subNav: {
            main: "#mapNavSubNav",
            parent: "#mapNavSubNavParent",
            lists: "#mapNavSubNavLists"
        },
        topNav: "#mapNavTopNav",
        search: "#mapNavSearch",
        villageSelect: "#mapNavVillageSelect",
    },
    detailZoom: 7,
    localCountryDetailZoom: 14,
    mapOptions: {
        mapTypeId: "map_style",
        center: {
            lat: 30,
            lng: 45
        },
        disableDefaultUI: !0,
        zoom: 2,
        zoomControl: !0,
        zoomControlOptions: {
            position: 1
        },
        maxZoom: SOSMapConfig.disableZoomToVillages ? 10 : null,
        scaleControl: !0,
        gestureHandling: "cooperative",
        disableDoubleClickZoom: !1,
        backgroundColor: "#b3d1ff"
    },
    staticUrl: document.location.protocol + "//" + document.location.host + "/maps/script/static.json",
    dynamicUrl: document.location.protocol + "//" + document.location.host + "/WebServices/WWHLocations/GetLocations",
    mapStyle: [{
        featureType: "landscape",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "water",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "administrative",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "administrative.province",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "landscape",
        elementType: "geometry",
        stylers: [{
            color: "#ffffff"
        }]
    }, {
        featureType: "road",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "transit",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "administrative.locality",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "poi",
        stylers: [{
            visibility: "off"
        }]
    }],
    mapStyleDetail: [{
        featureType: "administrative",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "administrative.country",
        elementType: "geometry.stroke",
        stylers: [{
            color: "#bfbfbf"
        }, {
            visibility: "on"
        }]
    }, {
        featureType: "administrative.country",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "administrative.locality",
        elementType: "labels",
        stylers: [{
            visibility: "on"
        }, {
            hue: "#ff0000"
        }]
    }, {
        featureType: "landscape",
        elementType: "all",
        stylers: [{
            saturation: "35"
        }, {
            lightness: "40"
        }, {
            hue: "#31ff00"
        }, {
            visibility: "on"
        }]
    }, {
        featureType: "landscape",
        elementType: "geometry",
        stylers: [{
            visibility: "on"
        }]
    }, {
        featureType: "landscape",
        elementType: "geometry.fill",
        stylers: [{
            visibility: "on"
        }]
    }, {
        featureType: "landscape",
        elementType: "labels.icon",
        stylers: [{
            visibility: "on"
        }]
    }, {
        featureType: "road.highway",
        elementType: "all",
        stylers: [{
            hue: "#ff5c00"
        }, {
            saturation: "21"
        }, {
            lightness: "48"
        }, {
            gamma: 1
        }]
    }, {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [{
            weight: "2.00"
        }]
    }, {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "road.highway",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "road.arterial",
        elementType: "all",
        stylers: [{
            hue: "#ff0300"
        }, {
            saturation: -100
        }, {
            lightness: 51.199999999999989
        }, {
            gamma: 1
        }]
    }, {
        featureType: "road.local",
        elementType: "all",
        stylers: [{
            hue: "#ff0300"
        }, {
            lightness: "52"
        }, {
            saturation: "-100"
        }]
    }, {
        featureType: "water",
        elementType: "geometry",
        stylers: [{
            visibility: "simplified"
        }, {
            weight: "0.50"
        }]
    }, {
        featureType: "water",
        elementType: "labels",
        stylers: [{
            visibility: "on"
        }]
    }],
    mapDataLayerStyles: {
        normal: {
            continent: {
                fillOpacity: 0,
                fillColor: "#74ba47",
                strokeColor: "#98b689",
                strokeWeight: 0,
                zIndex: 30
            },
            country: {
                fillOpacity: .5,
                fillColor: "#74ba47",
                strokeColor: "#98b689",
                strokeWeight: 1,
                zIndex: 10
            }
        },
        mouseOver: {
            country: {
                fillColor: "#74ba47",
                fillOpacity: 1,
                strokeColor: "#dceed3",
                strokeWeight: 1.25,
                zIndex: 20
            },
            continent: {
                fillColor: "#74ba47",
                fillOpacity: 1,
                strokeColor: "#dceed3",
                strokeWeight: 1
            }
        },
        active: {
            country: {
                fillColor: "#74ba47",
                fillOpacity: 1,
                strokeColor: "#dceed3",
                strokeWeight: 2,
                zIndex: 15,
                clickable: !1
            },
            continent: {}
        }
    },
    cluster: {
        normal: {
            1: {
                size: {
                    x: 36,
                    y: 42
                }
            },
            10: {
                size: {
                    x: 44,
                    y: 42
                }
            },
            100: {
                size: {
                    x: 52,
                    y: 42
                }
            }
        },
        novillage: {
            1: {
                size: {
                    x: 33,
                    y: 10
                }
            }
        }
    },
    marker: {
        "default": {
            normal: {
                icon: document.location.protocol + "//" + document.location.host + "/maps/img/icon-marker-null.png"
            },
            size: {
                x: 48,
                y: 42
            }
        }
    }
};